export const logsApiConfig = {
  host: process.env.LOGS_URL,
  URIS: {
    logAggregator: '/api/log-push-event',
  },
};
